/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { enumType } from "@pagopa/ts-commons/lib/types";
import * as t from "io-ts";

export enum WalletApplicationStatusEnum {
  "ENABLED" = "ENABLED",

  "DISABLED" = "DISABLED"
}

/**
 * Enumeration of wallet statuses
 */

export type WalletApplicationStatus = t.TypeOf<typeof WalletApplicationStatus>;
export const WalletApplicationStatus = enumType<WalletApplicationStatusEnum>(
  WalletApplicationStatusEnum,
  "WalletApplicationStatus"
);
